/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessage(data) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.add-to-wish-list', function (e) {
            e.preventDefault();

            var button = $(this);
            var url;
            var pid;

            if (button.hasClass('wishlistTile')) {
                pid = $(this).closest('.product').data('pid');
            } else {
                pid = $(this).closest('.product-detail-page').data('pid');
            }

            if (!pid) {
                return;
            }

            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;

            $.spinner().start();
            $(this).attr('disabled', true);

            // Heart button always adds to wishlist (never removes from list).
            url = $(this).data('href');
            if (!url) return;

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessage(data);
                    button.removeAttr('disabled');
                },
                error: function (err) {
                    displayMessage({
                        success: false,
                        msg: err.responseJSON.message
                    });
                    $(this).removeAttr('disabled');
                }
            });
        });
    }
};
